import getApplicationEnvironment from "@/utils/getApplicationEnvironment";

/*
  Returns the Everwrite app URL based on the current environment:
  - Production → https://writing.app.newsela.com
  - Staging → https://writing.app.staging.newseladev.com
  - All others (development, feature, local) → https://writing.app.dev.newseladev.com

  This intentionally avoids using NEXT_PUBLIC_OWN_HOST so links consistently target
  the correct Everwrite environment regardless of the host the app runs on.
*/

export const getEverwriteAppUrl = () => {
  const { isProductionEnv, isStagingEnv } = getApplicationEnvironment();
  if (isProductionEnv) return "https://writing.app.newsela.com";
  if (isStagingEnv) return "https://writing.app.staging.newseladev.com";
  return "https://writing.app.dev.newseladev.com";
};

export default getEverwriteAppUrl;
